// Paths are relative to the prefix in `getDocURL` below. The docs site was
// restructured (pages now live under `essentials/`, `automation/`, `reference/`,
// `getting-started/`, `use-cases/`); every non-empty path here was verified against
// the live site on 2026-08-07 (see #38470). Empty strings resolve to the docs
// homepage, which is the intended fallback for deprecated features.
export const docPaths = {
    // APPS
    allComponents: "essentials/components",
    button: "essentials/components/button",
    buttonBar: "", // DEPRECATED?
    formButton: "use-cases/forms",
    text: "essentials/components/text",
    comments: "essentials/components/collections/comments",
    compoundAction: "", // DEPRECATED?
    dateField: "essentials/components/date-pickers",
    dateTimeField: "essentials/components/date-pickers",
    emailField: "essentials/components/entry",
    email: "essentials/components/entry",
    favorite: "", // DEPRECATED?
    filePicker: "essentials/components/file-and-image-pickers",
    hint: "essentials/components/hint",
    imagePicker: "essentials/components/file-and-image-pickers",
    image: "essentials/components/image",
    addRelationColumn: "automation/computed-columns/relations",
    inlineList: "", // DEPRECATED?
    like: "", // DEPRECATED?
    link: "essentials/components/link",
    listReference: "automation/computed-columns/relations",
    locationEntry: "essentials/components/location",
    mapImage: "essentials/components/map",
    notes: "", // DEPRECATED?
    numberField: "essentials/components/entry",
    phoneField: "essentials/components/entry",
    // The phone display component has no page on the current docs site.
    phoneNumber: "essentials/components",
    actionText: "", // DEPRECATED?
    progress: "essentials/components/progress-bar",
    rating: "essentials/components/rating",
    reaction: "", // DEPRECATED?
    reference: "automation/computed-columns/relations",
    signature: "essentials/components/signature",
    simpleTable: "", // DEPRECATED?
    stopwatch: "", // DEPRECATED?
    textField: "essentials/components/entry",
    title: "essentials/components/title",
    toggle: "essentials/components/checkbox-and-switches",
    compoundComponent: "", // REALLY DEPRECATED
    userProfile: "essentials/security-and-user-data/user-profiles",
    webview: "", // DEPRECATED?
    youtube: "", // DEPRECATED
    choice: "essentials/components/choice",
    rowIDConfig: "automation/computed-columns/row-id-column",
    userSpecificColumns: "essentials/security-and-user-data/user-specific-columns",
    protectedColumns: "essentials/security-and-user-data/protected-columns",
    stripeFeesLearnMore: "", // DEPRECATED?
    dataLimits: "reference/account/updates",
    filters: "use-cases/conditions-filtering-and-visibility",
    tabVisibility: "essentials/security-and-user-data",
    templates: "getting-started/templates",
    templatePrivateInfo: "getting-started/templates",
    CAARecords: "reference/account/custom-domains",
    DNSStep2: "reference/account/custom-domains",
    DNSStep3: "reference/account/custom-domains",
    roles: "essentials/security-and-user-data/roles",
    supportCodes: "reference/account/support",
    scanInstall: "getting-started/quick-start",
    publishYourApp: "getting-started/quick-start",
    eventPicker: "", // DEPRECATED?
    separator: "",
    audioPlayer: "essentials/components/audio",
    videoPlayer: "essentials/components/video",
    markdown: "essentials/components/rich-text",
    yesCode: "automation/computed-columns/experimental-code-column",
    yesCodeCaveats: "automation/computed-columns/experimental-code-column#caveats",
    queryColumn: "automation/computed-columns/query-column",

    // PAGES
    pagesHint: "",
    pagesButton: "",
    pagesTitle: "",
    pagesButtons: "", // DEPRECATED?
    pagesBreadcrumbs: "",
    pagesFields: "essentials/components/fields",
    pagesRichText: "essentials/components/rich-text",
    pagesBigNumbers: "",
    pagesImage: "",
    pagesVideo: "",
    pagesSeparator: "essentials/components/separator",
    pagesCardCollection: "essentials/components/collections/card",
    pagesContactForm: "essentials/components/contact-form",

    // COMMON
    airtable: "essentials/data-sources/airtable",
    bigQuery: "essentials/data-sources/bigquery",
    bigTables: "essentials/data-sources/big-tables",

    // REFRESH
    refresh: "reference/user-experience/data-refresh",

    // COLUMNS
    mathColumn: "automation/computed-columns/math-column",
    templateColumn: "automation/computed-columns/template-column",
    ifThisThenElseColumn: "automation/computed-columns/if-then-else-column",
    lookupColumn: "automation/computed-columns/lookup-column",
    rollupColumn: "automation/computed-columns/rollup-column",

    style: "getting-started/intro-to-layout",
    actions: "automation/actions",
    visibility: "reference/user-experience/visibility-conditions",
    design: "essentials/components#design",
    data: "essentials/components#data",
    privacy: "essentials/users#access-and-privacy",

    dataEditor: "getting-started/introduction-to-the-data-editor",
    dataSources: "essentials/data-sources",

    troubleshooting: "reference/account/performance-analysis",
    performance: "reference/account/performance-analysis",

    infoSettings: "getting-started/app-settings#name--icon",
    appearanceSettings: "getting-started/app-settings#appearance",
};

export type Doc = keyof typeof docPaths;

export function getDocURL(target: Doc): string {
    return "https://glideapps.com/docs/" + docPaths[target];
}
